<template>
    <transition name="HotspotEntrance">
        <button class="Hotspot dropdownHotspot" v-show="ready" :class="[getHotspotMutatorClasses, getHotspotTypeClass]"
            :style="[getPosition]">
            <div class="Hotspot__button" :style="[getAlternateHotspotIcon]" @click="toggleDropdown"
                :class="{ 'open': activeDropdown === hotspot.id }"></div>
            <span v-html="getHotspotTitle" @click="toggleDropdown"></span>
            <transition name="dropdownHotspot">
                <div v-show="activeDropdown === hotspot.id" class="dropdownHotspot__list">
                    <router-link v-for="hotspot in hotspotList" :to="hotspot.route" :key="hotspot.id"
                        @click="hotspotPressed" :style="[getAlternateHotspotIcon]">
                        {{ hotspot.data.title }}
                    </router-link>
                </div>
            </transition>
        </button>
    </transition>
</template>

<script>

export default {
    props: ['hotspot', 'activeDropdown'],
    data() {
        return {
            ready: false,
            hotspotOpen: false,
            hotspotList: []
        }
    },
    created() {
        this.prepareHotspotList();
    },
    mounted() {
        this.renderHotspotCascade();
    },
    methods: {
        prepareHotspotList() {
            this.hotspotList = this.hotspot.children.map((hotspot, i) => {
                hotspot.route = app.api.PageManager.getHotspotRoute(hotspot);
                return hotspot;
            })
        },
        renderHotspotCascade() {
            let delay = 0;
            delay = (this.hotspot.index * 200) + 400;

            setTimeout(() => {
                this.ready = true;
            }, delay);
        },
        hotspotPressed() {
            this.$emit('hotspotPressed', this.hotspot)
        },
        toggleDropdown() {
            this.activeDropdown === this.hotspot.id ? this.$emit('currentDropdown', null) : this.$emit('currentDropdown', this.hotspot.id);
        },
    },
    computed: {
        getPosition() {
            return {
                left: this.hotspot.data.positionData.xPosition + 'px',
                top: this.hotspot.data.positionData.yPosition + 'px'
            }
        },
        getHotspotTitle() {
            return this.hotspot.data.alternateTitle && this.hotspot.data.alternateTitle !== '' ? this.hotspot.data.alternateTitle : this.hotspot.data.title;
        },
        getHotspotTypeClass() {
            let hotspotPrefix = "Hotspot--"

            switch (this.hotspot.data.hotspotType) {
                case "No Label":
                    return `${hotspotPrefix}NoLabel`

                // more types can be added here through the backend hotspotType data value.

                default:
                    return
            }
        },
        getHotspotMutatorClasses() {
            return {
                'Hotspot--flipped': this.hotspot.data.flipped,
                'Hotspot--customicon': this.hotspot.data.alternateHotspotIcon !== null
            }
        },
        getAlternateHotspotIcon() {
            if (this.hotspot.data.alternateHotspotIcon !== null) {
                return {
                    'background-image': `url(${app.api.Utils.getMediaPath(this.hotspot.data.alternateHotspotIcon.src)})`
                };
            }
        }
    }
}
</script>


<style lang="scss">
.dropdownHotspot {
    .Hotspot__button {
        transition: rotate 0.2s ease;

        &.open {
            rotate: 45deg;
            background-image: url(@/assets/img/ui/plus.svg)!important;
        }

        background-image: url(@/assets/img/ui/icon-lightning.svg);
        background-size: 16px;
    }

    span {
        height:100%;
        display: flex;
        align-items: center;
    }


&__list {
    position: absolute;
    top: calc(100% - 3px);
    min-width: 300%;
    margin: 5px 0 0 32px;

    a {
        background-image: url(@/assets/img/ui/icon-lightning-stroke.svg);
        background-repeat: no-repeat;
        background-position: 12px 12px;
        background-size: 12px;
        display: flex;
        align-items: center;
        font-weight: 500;
        color: var(--main-color);
        font-size: 15px;
        min-height: 38px;
        padding:0 15px 0 32px ;
        text-align: left;
        background-color: #fff;
        border-radius: 20px;
        width: fit-content;
        margin-top:5px;

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            background-color: var(--light-green);
            background-image: url(@/assets/img/ui/icon-lightning.svg);
        }
    }
}


&.Hotspot--flipped {
    .dropdownHotspot__list {
        margin: 0 32px 0 0;

        a {
            padding: 8px 16px 8px 20px;
        }
    }
}
}

/* dropdown animation */
.dropdownHotspot-enter-active,
.dropdownHotspot-leave-active {
    transition: all 0.4s var(--tk-easeinout);
}

.dropdownHotspot-enter-from {
    transform: translateY(-38px);
    opacity: 0;
}

.dropdownHotspot-leave-to {
    transform: translateY(-38px);
    opacity: 0;
}
</style>